export default "__VITE_ASSET__BqrLGhHV__"